import React from 'react';
import NotesPage from '../BasicComponents/tsgnotes';

const TSG = ({ mode = "learner" }) => {
  return <NotesPage mode={mode} />;
};

export default TSG;







